module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 06 > WLAN > Error State 2.914ba57f.jpg";